<template>
  <main>
    <div class="tab-content">
      <div class="row">
        <div class="col-12">
          <div class="radio radio-inline">
            <input type="radio" v-model="searchType" id="search-type-1" value="1" />
            <label for="search-type-1">遮蔽中</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" v-model="searchType" id="search-type-2" value="2" />
            <label for="search-type-2">已解除</label>
          </div>
          <hr />
          <div class="col-12 p-0 d-flex align-items-center">
            <select
              :id="`param-type`"
              :data-vv-name="`param-type`"
              v-validate="'required'"
              data-vv-as="查詢條件"
              data-vv-scope="IDs"
              style="width: 15%;"
              class="form-control form-control-inline mr-2"
              v-model="selectKey"
              :class="{ 'is-invalid': errors.has('IDs.param-type') }"
            >
              <option value>請選擇</option>
              <option v-for="(key, value, index) in selectOption" :key="`param-type-${index}`" :value="value">
                {{ key }}
              </option>
            </select>
            <input
              type="text"
              :id="`search-param`"
              :data-vv-name="`search-param`"
              v-validate="'required'"
              data-vv-as="查詢條件"
              data-vv-scope="IDs"
              class="form-control mr-1"
              v-model="selectVal"
              style="width: 20%;"
              alt="ch"
              :class="{ 'is-invalid': errors.has('IDs.search-param') }"
            />
            <a class="btn btn-primary" @click="doQuery('val')">查詢</a>
          </div>
          <hr />
          <div class="col-12 p-0 d-flex align-items-center">
            <span class="mr-2">遮蔽期間</span>
            <select
              :id="`start-date-year`"
              :data-vv-name="`start-date-year`"
              v-validate="'required'"
              data-vv-as="遮蔽日期(起)"
              data-vv-scope="Dates"
              class="form-control form-control-inline"
              v-model="start_date[0]"
              :class="{ 'is-invalid': errors.has('Dates.start-date-year') }"
            >
              <option value>年份</option>
              <option v-for="(opt, y_opt_i) in yearOpt" :key="`start-year-${y_opt_i}`" :value="opt">
                {{ opt - 1911 }}年
              </option>
            </select>
            <span class="text">/</span>
            <select
              :id="`start-date-month`"
              :data-vv-name="`start-date-month`"
              v-validate="'required'"
              data-vv-as="遮蔽日期(起)"
              data-vv-scope="Dates"
              class="form-control form-control-inline mr-2"
              v-model="start_date[1]"
              :class="{ 'is-invalid': errors.has('Dates.start-date-month') }"
            >
              <option value>月份</option>
              <option v-for="(opt, m_opt_i) in monthOpt" :key="`start-month-${m_opt_i}`" :value="opt">
                {{ opt }}月
              </option>
            </select>

            <span class="mr-2">~</span>

            <select
              :id="`end-date-year`"
              :data-vv-name="`end-date-year`"
              v-validate="'required'"
              data-vv-as="遮蔽日期(訖)"
              data-vv-scope="Dates"
              class="form-control form-control-inline"
              v-model="end_date[0]"
              :class="{ 'is-invalid': errors.has('Dates.end-date-year') }"
            >
              <option value>年份</option>
              <option v-for="(opt, y_opt_i) in yearOpt" :key="`end-year-${y_opt_i}`" :value="opt">
                {{ opt - 1911 }}年
              </option>
            </select>
            <span class="text">/</span>
            <select
              :id="`end-date-month`"
              :data-vv-name="`end-date-month`"
              v-validate="'required'"
              data-vv-as="遮蔽日期(訖)"
              data-vv-scope="Dates"
              class="form-control form-control-inline mr-1"
              v-model="end_date[1]"
              :class="{ 'is-invalid': errors.has('Dates.end-date-month') }"
            >
              <option value>月份</option>
              <option v-for="(opt, m_opt_i) in monthOpt" :key="`end-month-${m_opt_i}`" :value="opt">
                {{ opt }}月
              </option>
            </select>
            <a class="btn btn-primary" @click="doQuery()">查詢</a>
          </div>
          <br />
          <!-- 資料呈現區塊 -->
          <table id="bullentin_datatable" class="table datatable table-striped area-list-datatable">
            <thead>
              <tr>
                <th>#</th>
                <th
                  id="col_FORM_NO"
                  :class="
                    'sorting ' + (order.fieldName == 'FORM_NO' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('FORM_NO')"
                  class="text-center"
                >
                  簡覆表編號
                </th>
                <th
                  id="col_POLICY_NO"
                  :class="
                    'sorting ' + (order.fieldName == 'POLICY_NO' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('POLICY_NO')"
                >
                  保單號碼
                </th>
                <th
                  id="col_ID"
                  :class="'sorting ' + (order.fieldName == 'ID' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="processList('ID')"
                >
                  被保人ID
                </th>
                <th
                  id="col_START_DATE"
                  :class="
                    'sorting ' + (order.fieldName == 'START_DATE' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('START_DATE')"
                >
                  遮蔽起日
                </th>
                <th
                  id="col_END_DATE"
                  :class="
                    'sorting ' + (order.fieldName == 'END_DATE' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('END_DATE')"
                >
                  遮蔽迄日
                </th>
                <th
                  id="col_AGNT_ID"
                  :class="
                    'sorting ' + (order.fieldName == 'AGNT_ID' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('AGNT_ID')"
                >
                  業務員ID
                </th>
                <th
                  id="col_AGNTNM"
                  :class="
                    'sorting ' + (order.fieldName == 'AGNTNM' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('AGNTNM')"
                >
                  業務員姓名
                </th>
                <th
                  id="col_AGNTDIVNM"
                  :class="
                    'sorting ' + (order.fieldName == 'AGNTDIVNM' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('AGNTDIVNM')"
                >
                  業務員單位
                </th>
                <th
                  id="col_INPUTNM"
                  :class="
                    'sorting ' + (order.fieldName == 'INPUTNM' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('INPUTNM')"
                >
                  輸入人員
                </th>
                <th
                  id="col_UPD_TIME"
                  :class="
                    'sorting ' + (order.fieldName == 'UPD_TIME' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('UPD_TIME')"
                >
                  輸入日期
                </th>
                <th id="col_MEMO">備註</th>
                <template v-if="searchType === '1'">
                  <th id="col_function" ref="lastCol" class="text-center">功能</th>
                </template>
                <template v-else>
                  <th id="col_deleteMember" class="text-center">刪除<br />人員</th>
                  <th id="col_deleteDate" ref="lastCol" class="text-center">刪除<br />日期</th>
                </template>
              </tr>
            </thead>
            <tbody id="bullentin-view" v-if="rtnList.length > 0">
              <tr v-for="(item, index) in rtnList" :key="`td-rtnList-${index}-${item.ser_no}`">
                <td>{{ index + 1 }}</td>
                <td>{{ item.FORM_NO }}</td>
                <td>{{ item.POLICY_NO }}</td>
                <td>{{ item.ID |getMaskID}}</td>
                <td class="text-center">
                  <div class="date">{{ item.START_DATE | dateFormat }}</div>
                </td>
                <td class="text-center">
                  <div class="date">{{ item.END_DATE | dateFormat }}</div>
                </td>
                <td>{{ item.AGNT_ID |getMaskID}}</td>
                <td>{{ item.AGNTNM |getMaskName}}</td>
                <td>{{ item.AGNTDIVNM }}</td>
                <td>{{ item.INPUTNM |getMaskName}}</td>
                <td class="text-center">
                  <div class="date">{{ item.UPD_TIME | dateFormat }}</div>
                </td>
                <td>{{ item.MEMO }}</td>
                <template v-if="searchType === '1'">
                  <td width="5%">
                    <a class="text-green text-underline pointer-cursor" @click="doDelete(item, index)">解除</a>
                  </td>
                </template>
                <template v-else>
                  <td>{{ item.DELETEIDNM |getMaskName}}</td>
                  <td>{{ item.DELETE_TIME | dateFormat }}</td>
                </template>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="13" class="empty">
                  <h3 class="text-center py-5">無任何資料</h3>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { commonMixin } from '@/mixins/common';
import { setTimeout } from 'timers';

//component
import TabHeaderBullentin from '@/desktop/components/backend/TabHeaderBullentin';
import BullentinContent from '@/desktop/views/backend/BullentinContent';
import mxMask from '@/desktop/components/mxMask';
//service
import { queryPolicyCovered, deletePolicyCovered, queryPolicyCoveredDelete } from '@/service';
//parameter
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad

export default {
  name: 'policyCoveredEdit',
  mixins: [commonMixin],
  components: {
    TabHeaderBullentin,
    BullentinContent,
    mxMask
  },
  data() {
    return {
      searchType: '1',
      mxMaskOpen: false,
      start_date: [this.moment().year(), this.moment().month() + 1],
      end_date: [this.moment().year(), this.moment().month() + 1],
      yearOpt: [],
      selectOption: {
        form_no: '簡覆表編號',
        agnt_id: '業務員ID',
        id: '被保人ID',
        policy_no: '保單號碼'
      },
      selectKey: '',
      selectVal: '',
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      rtnList: [], //顯示資料
      order: {
        fieldName: 'subject',
        asc: true
      },
      iPadWidth: 364
    };
  },
  computed: {
    ...mapGetters(['BaseUrl', 'UserInfo'])
  },
  methods: {
    ...mapActions(['setPageLock']),
    //欄位排序
    processList(fieldName) {
      let order = this.order;
      if (order.fieldName == fieldName) {
        order.asc = !order.asc;
      } else {
        order.fieldName = fieldName;
        order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case 'START_DATE':
          setTimeout(() => {
            this.rtnList.sort(this.dateCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        case 'END_DATE':
          setTimeout(() => {
            this.rtnList.sort(this.dateCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            this.rtnList.sort(this.sortCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function (a, b) {
        const ar = a[property] ? a[property] : '';
        const br = b[property] ? b[property] : '';
        let result = ar < br ? -1 : ar > br ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function (a, b) {
        let date_a = new Date(a[property] ? a[property] : '1880-01-01').getTime();
        let date_b = new Date(b[property] ? b[property] : '1880-01-01').getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    //查詢
    doQuery(selectKey) {
      let scope;
      if (selectKey) {
        scope = 'IDs';
        this.errors.clear('Dates');
      } else {
        scope = 'Dates';
        this.errors.clear('IDs');
      }
      this.rtnList = [];
      this.$validator.validateAll(scope).then(el => {
        if (!el) {
          let errMsg = [];
          this.errors.items.forEach(x => errMsg.push(x.msg));
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }

        let reqData = {};
        if (!selectKey) {
          let startDate = ''; //查詢的起始日
          let endDate = ''; //查詢的結束日
          let lastDay = ''; //每月最後一天

          let startMonth =
            this.start_date[1].toString().length == 1
              ? '0' + this.start_date[1].toString()
              : this.start_date[1].toString();
          let endMonth =
            this.end_date[1].toString().length == 1 ? '0' + this.end_date[1].toString() : this.end_date[1].toString();

          let start = this.start_date[0] + startMonth;
          let end = this.end_date[0] + endMonth;
          if (parseInt(start) > parseInt(end)) {
            this.setToastMsg('遮蔽日期起始日不可大於結束日');
            return;
          }
          lastDay = new Date(this.end_date[0], parseInt(this.end_date[1]), 0).getDate();
          startDate = `${this.start_date[0]}-${startMonth}-01`;
          endDate = `${this.end_date[0]}-${endMonth}-${lastDay}`;

          reqData = {
            start_month: startDate,
            end_month: endDate
          };
        } else {
          reqData[this.selectKey] = this.selectVal;
        }
        this.$validator.reset();
        this.mxMaskOpen = true;
        const fn = this.searchType === '1' ? queryPolicyCovered : queryPolicyCoveredDelete;

        fn(this.UserInfo.id, reqData).then(result => {
          this.mxMaskOpen = false;
          if (result.header && result.header.status == '200') {
            this.rtnList = result.body;
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      });
    },
    doDelete(item, index) {
      debugger;
      const reqData = {
        agnt_id: item.AGNT_ID,
        id: item.ID,
        policy_no: item.POLICY_NO
      };
      this.mxMaskOpen = true;
      deletePolicyCovered(this.UserInfo.id, reqData).then(result => {
        this.mxMaskOpen = false;
        if (result.header && result.header.status == '200') {
          this.$toast.info({ title: '解除遮蔽成功' });
          this.rtnList.splice(index, 1);
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //欄位寬度初始化
    initColWidth() {
      if (!is_iPad) {
        this.iPadWidth = this.$refs.lastCol.clientWidth - 15;
      } else {
        this.iPadWidth = this.$refs.lastCol.clientWidth;
      }
    }
  },
  watch: {
    searchType() {
      this.rtnList = [];
    }
  },
  mounted() {
    let start = window.moment().year();
    for (let s = start - 2; s <= start + 2; s++) {
      this.yearOpt.push(s);
    }
    this.initColWidth();
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
.table.datatable {
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}
</style>
